<template>
  <div class="top">
    <span @click="home">{{TLang('首页','home')}}</span>
    <img :src="staticAssets.ImgObj.arrow_right" alt class="arrow"/>
    <span @click="toList" :class="{ detail: !categoryId }">{{ listName }}</span>
    <img :src="staticAssets.ImgObj.arrow_right" alt class="arrow"  v-if="showName"/>
    <span v-if="showName" class="detail">{{ showName }}</span>
  </div>
</template>

<script>
export default {
  name: "topShow",
  props: {
    listName: String,
    categoryId: [String, Number],
    parentId: [String, Number],
    city: [String, Number],
    showName: String,
  },
  methods: {
    home() {
      this.$router.push({
        path: "/",
      });
    },
    toList() {
      if (this.categoryId) {
        this.$router.push({
          path: "/list",
          query: {
            categoryId: this.categoryId,
            parentId: this.parentId,
            city: this.city,
          },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.top {
  position: relative;
  color: #666;
  margin: 0 0 20px 0;
  font-size: 14px;
  font-weight: normal;
  display: flex;
  align-items: center;
  .arrow {
    width: 16px;
    height: 16px;
    margin: 0 5px;
  }
  span {
    display: inline-block;
  }
  span:last-child {
    cursor: default;
  }
  i {
    display: inline-block;
    position: relative;
    top: 1px;
    height: 17px;
    line-height: 17px;
  }
  .right {
    color: #666;
  }
  .detail:hover {
    color: #666;
  }
}
</style>
